<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import './assets/css/common.css'
import DevicePixelRatio from './utils/device'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  created() {
    // new DevicePixelRatio().init();
  },
  components: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue